<template>
    <section class="inner-article-container bg-fadeblue">
        <div class="page-container">
            <div class="heading">
                <h2 class="heading__h3 left">Featured Offers</h2>
            </div>
            <VueSlickCarousel v-if="this.featuredOffers && this.featuredOffers.length" v-bind="settings" class="three-slider">

                <div v-for="(item, index) in this.featuredOffers" :key="item.OfferId+index">
                    <div class="">
                        <offers-block-component view="'block'" :key="item.OfferId" :offer="item"> </offers-block-component>
                    </div>
                </div>
            </VueSlickCarousel>

        </div>
    </section>
</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    // import FeaturedOfferComponent from './FeaturedOfferComponent.vue'
    import OffersBlockComponent from './OffersBlockComponent.vue'

    export default {
        name: "FeaturedOffersSliderComponent",
        components: {
            VueSlickCarousel,
            OffersBlockComponent
        },
        props: ['featuredOffers'],
        data() {
            return {
                settings: {
                    infinite: true,
                    autoplay: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    pauseOnHover: true,
                    speed: 500,
                    arrows: true,
                    dots: false,
                    responsive: [
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                },
            }
        },

        mounted() {

            // console.log(this.featuredOffers, 'featured offers');
        },
        watch: {

            featuredOffers: function (val) {
                // console.log(val, 'featured offers 2');
            }
        }
    }
</script>
